import { REACT_APP_INTAKE_DEVTOOLS } from '../config';

/**
 * Fail-closed: solo el literal 'true' prende las herramientas. Cualquier otra
 * cosa — vacío, 'false', 'on', un typo — las deja apagadas.
 *
 * CRA inlinea la variable en tiempo de build, así que en un bundle donde no
 * está definida esto es `false` constante y el `React.lazy` que cuelga de acá
 * nunca se pide.
 */
export function intakeDevToolsEnabled(): boolean {
  return String(REACT_APP_INTAKE_DEVTOOLS).trim() === 'true';
}
